module.exports = function(mapElement) {
    mapElement.textContent = '';
    var bts = {lat: 55.474612, lng: -4.630405};
    var map = new google.maps.Map(mapElement, {
        center: bts,
        zoom: 14,
        styles: require('./mapstyles.js')
    });
    var marker = new google.maps.Marker({position: bts, map: map});
}